'use strict';

/**
 * Activates an option
 */
export default (combobox, listbox) => {

	// clean
	let cleanArray = Array.from(listbox.querySelectorAll('[role="option"].accessible-option-active'));

	cleanArray.forEach((o) => o.classList.remove('accessible-option-active'));

	const optionID = combobox.getAttribute('aria-activedescendant');
	const active = optionID && document.getElementById(optionID);
	if (active) {
		active.classList.add('accessible-option-active');
	}
	if (active) {
		setTimeout(() => {
			// if the selected option is lower than the visible area
			if (active.offsetTop + active.offsetHeight > listbox.scrollTop + listbox.offsetHeight) {
				listbox.scrollTop = active.offsetTop - ((listbox.offsetHeight - active.offsetHeight) / 2);
			}
			// if the selected option is higher than the visible area
			if (active.offsetTop < listbox.scrollTop) {
				listbox.scrollTop = active.offsetTop - ((listbox.offsetHeight - active.offsetHeight) / 2);
			}
		});
	}
};
